//指数版本记录

import UltMeta, { Meta } from "./UltMeta/index";

class State extends UltMeta {
    TO_BE_SUBMIT = new Meta(1, "待提交");
    REJECTED = new Meta(2, "已驳回");
    TO_BE_PUBLISH = new Meta(3, "待发布");
    REVOKED = new Meta(4, "已撤回");
    PUBLISHED = new Meta(5, "已发布");
}

export const STATE = new State();
